import AdaptiveDialog, {
  AdaptiveDialogContent,
} from "@/lib/components/ui/adaptive-dialog/adaptive-dialog";
import { ImperativeDialogContent } from "./imperative-dialog.content";
import {
  dismiss,
  getServerSnapshot,
  getSnapshot,
  resolveFromUserAction,
  subscribe,
} from "./imperative-dialog.store";
import type {
  ImperativeDialogCustomProps,
  ImperativeDialogVariant,
} from "./imperative-dialog.types";
import errorCoverUrl from "./assets/error-cover.png";
import successCoverUrl from "./assets/success-cover.png";
import { useSyncExternalStore, type ReactNode } from "react";

const coverImageClassName = "hidden h-full rounded-l-lg object-cover md:block";

function buildResolvedCover(
  variant: ImperativeDialogVariant,
  cover: ImperativeDialogCustomProps["cover"],
): ReactNode | null {
  if (cover === null) {
    return null;
  }
  if (cover !== undefined) {
    if (typeof cover === "string") {
      return <img alt="" className={coverImageClassName} src={cover} />;
    }
    return cover;
  }
  if (variant === "error") {
    return <img alt="" className={coverImageClassName} src={errorCoverUrl} />;
  }
  if (variant === "success") {
    return <img alt="" className={coverImageClassName} src={successCoverUrl} />;
  }
  return null;
}

export function ImperativeDialogRoot() {
  const entry = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  const open = entry !== null;

  return (
    <AdaptiveDialog
      onOpenChange={function handleImperativeDialogOpenChange(
        nextOpen: boolean,
      ) {
        if (!nextOpen) {
          dismiss();
        }
      }}
      open={open}
    >
      {open && entry ? (
        <AdaptiveDialogContent
          width="max-w-3xl"
          classNames={{ content: "px-0 md:p-0" }}
          aria-describedby={undefined}
        >
          <ImperativeDialogContent
            action={entry.props.action}
            children={
              entry.variant === "custom"
                ? (entry.props.children ?? undefined)
                : undefined
            }
            cover={buildResolvedCover(entry.variant, entry.props.cover)}
            description={entry.props.description}
            eyebrow={entry.props.eyebrow}
            onActionClick={function handleImperativeDialogPrimary() {
              void resolveFromUserAction("action");
            }}
            onSecondaryActionClick={function handleImperativeDialogSecondary() {
              void resolveFromUserAction("secondaryAction");
            }}
            secondaryAction={entry.props.secondaryAction}
            title={entry.props.title}
          />
        </AdaptiveDialogContent>
      ) : null}
    </AdaptiveDialog>
  );
}
